import Vue from "vue";
import Router from "vue-router";
import Startseite from "./views/Startseite.vue";
import Start from "./views/Start.vue";

// import Registrierung from './views/MachMit/Registrierung.vue'
// import Anmeldung from './views/MachMit/Anmeldung.vue'
// import LoginBereich from "./views/MachMit/LoginBereich.vue"
// import Spielregeln from "./views/MachMit/Spielregeln.vue"
import Aktuelles from "./views/Aktuelles.vue";
import Termine from "./views/Termine.vue";

// PROJEKT
import Projekt from "./views/Projekt/Index.vue";
import Info from "./views/Projekt/Info.vue";
import Presse from "./views/Projekt/Presse.vue";
import Mitwirkung from "./views/Projekt/Mitwirkung.vue";
import Bericht from "./views/Projekt/Bericht.vue";
import Kunst from "./views/Projekt/Kunst.vue";
import Prozess from "./views/Projekt/Prozess.vue";
// import Video from "./views/Projekt/Video.vue";
import Downloads from "./views/Projekt/Downloads.vue";
import Arbeitsgruppe from "./views/Projekt/Arbeitsgruppe.vue";
import Onlineumfrage from "./views/Projekt/Onlineumfrage.vue";
import Buergerwerkstatt from "./views/Projekt/Buergerwerkstatt.vue";
import Leitbild from "./views/Projekt/Leitbild.vue";

//PROJEKT/MACHMIT
import MachMit from "./views/MachMit/Index.vue";
import Karte from "./views/MachMit/Karte.vue";
import Auswertung from "./views/MachMit/Auswertung.vue";
import Umfrage from "./views/MachMit/Umfrage.vue";
import Ideenbaum from "./views/MachMit/Ideenbaum.vue";
import Kinderstadt from "./views/MachMit/Kinderstadt.vue";

import Datenschutz from "./views/Datenschutz.vue";
import Impressum from "./views/Impressum.vue";
import Kontakt from "./views/Kontakt.vue";
import store from "./store";

import Meta from "vue-meta";

Vue.use(Router);
Vue.use(store);
Vue.use(Meta);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      resolve({
        x: 0,
        y: 0
      });
    });
  },
  mode: "history",
  // base: process.env.BASE_URL,
  base: "/",
  assetsPublicPath: "/",
  routes: [
    {
      path: "/",
      name: "startseite",
      component: Startseite
    },
    {
      path: "/start",
      name: "start",
      component: Start
    },

    {
      path: "/aktuelles",
      name: "aktuelles",
      component: Aktuelles
    },

    {
      path: "/termine",
      name: "termine",
      component: Termine
    },
    {
      path: "/projekt",
      name: "projekt",
      component: Projekt,
      redirect: { name: "prozess" },
      children: [
        {
          path: "info",
          name: "info",
          component: Info
        },
        {
          path: "presse",
          name: "presse",
          component: Presse
        },
        {
          path: "mitwirkung",
          name: "mitwirkung",
          component: Mitwirkung
        },
        {
          path: "bericht",
          name: "bericht",
          component: Bericht
        },
        {
          path: "kunst",
          name: "kunst",
          component: Kunst
        },
        {
          path: "prozess",
          name: "prozess",
          component: Prozess
        },
        {
          path: "downloads",
          name: "downloads",
          component: Downloads
        },
        {
          path: "arbeitsgruppe",
          name: "arbeitsgruppe",
          component: Arbeitsgruppe
        },
        {
          path: "onlineumfrage",
          name: "onlineumfrage",
          component: Onlineumfrage
        },
        {
          path: "buergerwerkstatt",
          name: "buergerwerkstatt",
          component: Buergerwerkstatt
        },
        {
          path: "leitbild",
          name: "leitbild",
          component: Leitbild
        },
        {
          path: "machmit",
          name: "machmit",
          component: MachMit,
          redirect: {
            name: "umfrage"
          },

          children: [
            {
              path: "karte",
              name: "karte",
              component: Karte
            },
            {
              path: "auswertung",
              name: "auswertung",
              component: Auswertung
            },
            {
              path: "umfrage",
              name: "umfrage",
              component: Umfrage
            },
            {
              path: "ideenbaum",
              name: "ideenbaum",
              component: Ideenbaum
            },
            {
              path: "kinderstadt",
              name: "kinderstadt",
              component: Kinderstadt
            }
          ]
        }
      ]
    },
    {
      path: "/datenschutz",
      name: "datenschutz",
      component: Datenschutz
    },
    {
      path: "/impressum",
      name: "impressum",
      component: Impressum
    },
    {
      path: "/kontakt",
      name: "kontakt",
      component: Kontakt
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

// router.beforeEach((from, to, next) =>
//   setTimeout(() => next(), 100)
// )
export default router;
